import React, { lazy } from 'react';

import { type RouteObject } from 'react-router-dom';

const BulkLogDownLoadPage = lazy(
  () => import('./pages/download/download.page'),
);
export const logDownloadRoutes: RouteObject = {
  path: '/bulk-log-download/:queryId/:outputId/:fileId',
  element: <BulkLogDownLoadPage />,
};
